import {useState, useContext, useEffect} from "react"
import {useNavigate, useLocation} from "react-router-dom"
import {Form, Field} from "react-final-form"
import {WrapperContainer, Radio, AlertDialog, Button} from "ui"
import {
  PET_ALLOWED_QUESTION,
  PET_ALLOWED_ALERT,
  PET_ALLOWED_ITEMS,
  BLOCKED_PET_ALLOWED
} from "../../../../constants/accounts/veterinary"
import {RoutePaths, FormButton} from "../../../../constants"
import {nacMachineContext} from "../../../../context"
import {NACEvents, NACStates} from "../../../../machine/nac-machine.types"

const AllowPet = () => {
  const [open, setOpen] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()
  const {state, send} = useContext(nacMachineContext) || {}

  const renderAlertBox = () => {
    return (
      <AlertDialog
        open={open}
        setOpen={setOpen}
        title={PET_ALLOWED_ALERT.title}
        description={PET_ALLOWED_ALERT.description}
        handleConfirm={() => window.open(PET_ALLOWED_ALERT.contactURL, "_blank")}
        labelConfirm="Contact Us"
      />
    )
  }

  const onSubmit = (values: {petAllow: string}) => {
    if (BLOCKED_PET_ALLOWED.includes(parseInt(values.petAllow))) {
      setOpen(true)
    } else {
      send(NACEvents.NEXT, {data: values})
      navigate(RoutePaths.ACCOUNT_STORE_LOCATION)
    }
  }

  useEffect(() => {
    if (state?.value !== NACStates.validatePetAllow) {
      send(NACEvents.INIT, {data: {route: location.pathname}})
    }
  }, [])
  return (
    <div className="flex justify-center">
      <div className="w-full sm:w-[520px]">
        <WrapperContainer>
          <p className="mb-3 font-bold text-gray-700">{PET_ALLOWED_QUESTION}</p>

          <Form
            onSubmit={onSubmit}
            initialValues={{petAllow: state.context.validatePet?.petAllow}}
            render={({handleSubmit, invalid}) => (
              <form onSubmit={handleSubmit}>
                <div className=" flex flex-col gap-2">
                  {PET_ALLOWED_ITEMS.map(item => {
                    return (
                      <Field
                        key={item.id}
                        name={item.name}
                        component={Radio}
                        type="radio"
                        value={`${item.value}`}
                        label={item.label}
                        validate={value => (value ? undefined : "Required")}
                      />
                    )
                  })}
                </div>
                <div className="mt-10 flex justify-end gap-8">
                  <Button
                    variant="text"
                    onClick={() => {
                      send(NACEvents.BACK)
                      navigate(RoutePaths.ACCOUNT_PET)
                    }}
                  >
                    {FormButton.BACK}
                  </Button>
                  <Button
                    disabled={invalid}
                    variant="primary"
                    mode="filled"
                    type="submit"
                  >
                    {FormButton.CONTINUE}
                  </Button>
                </div>
              </form>
            )}
          />
          {renderAlertBox()}
        </WrapperContainer>
      </div>
    </div>
  )
}

export default AllowPet
